module.exports = __webpack_public_path__ + "static/media/INV-0287 - Administrative Penalty Order - Harjot Khehra.38bbd60f.pdf";